import { render, staticRenderFns } from "./ChangeOrders.vue?vue&type=template&id=4cb4d5c4"
import script from "./ChangeOrders.vue?vue&type=script&lang=js"
export * from "./ChangeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports